import { Device } from './../../../common/interfaces/item.interface';
import { Observable } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProgrammingUtilsService as Utils } from './../../../common/services/utils.service';
import { SharedProgrammingService } from './../../../common/services/shared-programming.service';
import { CommonProgrammingContext } from '../../../common/services/shared-programming.service';
import { Store } from '@ngrx/store';


@Component({
  selector: 'prg-select-system',
  templateUrl: './select-system.component.html',
  styleUrls: ['./select-system.component.less']
})
export class SelectSystemComponent implements OnInit {
  devices: Observable<Array<Device>>;

  constructor(
    protected store: Store<{sharedProgramming: CommonProgrammingContext}>,
    protected route: ActivatedRoute,
    protected router: Router,
    protected shared: SharedProgrammingService
  ) {
    this.devices = this.store.select(s => s.sharedProgramming.trigger.devices);
  }

  ngOnInit() {
    this.shared.getTriggerDevices({ proxy: { $in: ['security'] } });
  }

  systemSelected(system: Device) {
    this.shared.setTriggerDevice(system);
    this.router.navigate(['../event'], { relativeTo: this.route });
  }
}



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-security-system/select-system/select-system.component.ts